import React, { Component } from 'react';
import DeclaracionesJuradas from './Declaraciones Juradas';
import AltaDocentes from './AltaDocente';

class Formularios extends Component {



    render() {
        return (
            <div className='seccion'>

                <DeclaracionesJuradas/>

                <AltaDocentes/>
                
            </div>
        );
    }
}

export default Formularios;
